import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { ProviderSpecialty } from 'app/core/models/provider-specialty.model';
import { ReferralSpecialty } from '../models/referral-specialty.model';

@Injectable()
export class ProviderSpecialtyService extends ApiService {
  private http = inject(HttpClient);


  getList(): Observable<{ providerSpecialties: ProviderSpecialty[] }> {
    return this.http.get<{ providerSpecialties: ProviderSpecialty[] }>(
      `${environment.captureApi.url}/provider_specialties`
    );
  }

  getReferralSpecialties(): Observable<ReferralSpecialty[]> {
    return this.http.get<ReferralSpecialty[]>(
      `${environment.captureApi.url}/provider_specialties/referral_specialties`
    );
  }
}
